import { type Company, type Team } from '~/common/types/company/company';
import config from '@/config/config';
import { type Contact } from '~/common/types/contact/contact';
import createRestClient from '../restClient';
import { type CrmAutoCompleteOption } from '~/common/types';
import { type CrmOptionType } from '~/common/enums';

const client = createRestClient(config.baseURL);

const getCrmAutocomplete = ({
  bookyearId,
  buildingId,
  hoaId,
  hoaRelationsOnly,
  includeCentralCompanies,
  includeCompanies,
  includeContacts,
  includeTeams,
  hasFinancialInfo,
  unitId,
}: {
  bookyearId?: string;
  buildingId?: string;
  hoaId?: string;
  hoaRelationsOnly?: boolean;
  includeCentralCompanies?: boolean;
  includeCompanies?: boolean;
  includeContacts?: boolean;
  includeTeams?: boolean;
  hasFinancialInfo?: boolean;
  unitId?: string | null;
}): Promise<CrmAutoCompleteOption[]> =>
  client.get('/crm/autocomplete', {
    params: {
      bookyearId,
      buildingId,
      hasFinancialInfo,
      hoaId,
      hoaRelationsOnly,
      includeCentralCompanies,
      includeCompanies,
      includeContacts,
      includeTeams,
      unitId,
    },
  });

const getCrmEntityInfo = ({
  id,
  type,
}: {
  id: string;
  type: CrmOptionType;
}): Promise<Company | Contact | Team> => client.get('/crm/entity-info', { params: { id, type } });

export default {
  getCrmAutocomplete,
  getCrmEntityInfo,
};
